<template>
  <div class="custom-height-100p">
    <div class="header">
      <div
        v-for="item in tabs"
        :key="item.key"
        :class="['custom-cursor-pointer tab-title', { active: defaultActiveKey === item.key }]"
        @click="changeTab(item.key)"
      >
        {{item.name}}
      </div>
    </div>
    <order v-if="defaultActiveKey === 'order'" />
    <tomorrow-item v-if="defaultActiveKey === 'tomorrow_item'" />
  </div>
</template>

<script>
import Order from '@/views/home/big_screen/Order'
import TomorrowItem from '@/views/home/big_screen/TomorrowItem'
export default {
  name: 'BigScreenHome',
  components: {
    Order,
    TomorrowItem
  },
  data() {
    return {
      defaultActiveKey: 'order',
      tabs: [
        { key: 'order', name: '进行中的订单' },
        { key: 'tomorrow_item', name: '明日事项' }
      ]
    }
  },
  methods: {
    changeTab(key) {
      this.defaultActiveKey = key
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  display: flex;
  position: fixed;
  top: 20px;
  right: 200px;

  .tab-title {
    margin: 0 10px;
    color: #ffd794ff;

    &.active {
      color: rgba(206, 123, 58, 100%);
      border-bottom: 2px solid rgba(206, 123, 58, 100%);
      padding-bottom: 5px;
    }
  }
}
</style>

